import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=2b091c41&"
import script from "./AssetTable.vue?vue&type=script&lang=ts&"
export * from "./AssetTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports